import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  icon,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {icon && (
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-50 text-accent-500">
              <i className={icon}></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 text-sm text-secondary-600">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 text-sm font-medium text-secondary-600 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}